export enum CouponStatus {
    active = 1,
    not_active = 2,
    finished = 3,
  }
  